import { Directive, ViewContainerRef } from "@angular/core";
import { DataTable } from "@bfx/primeng/datatable";
import { NativeDesktopSupport } from "./native-desktop-support";

@Directive({
  selector: "[nativeDesktopTable]",
  standalone: false,
})
export class NativeDesktopTable {
  constructor(view: ViewContainerRef) {
    let component = view.injector.get(DataTable);
    NativeDesktopTable.initialize(component);
  }

  public static initialize(component: DataTable): void {
    if (component instanceof DataTable && NativeDesktopSupport.isNativeDesktopContainer()) {
      let dataTable: DataTable = component;
      let element = dataTable.el;

      dataTable.unbindColumnResizeEvents();

      dataTable.unbindColumnResizeEvents = function unbindColumnResizeEvents(this: DataTable) {
        let document = NativeDesktopSupport.getWindow(element.nativeElement).getNativeWindow()
          .document;

        document.removeEventListener("mousemove", this.onDocumentMouseMove);

        if (this.documentColumnResizeEndListener) {
          this.documentColumnResizeEndListener();
          this.documentColumnResizeEndListener = null;
        }
      }.bind(dataTable);

      dataTable.bindColumnResizeEvents = function bindColumnResizeEvents(this: DataTable) {
        let document = NativeDesktopSupport.getWindow(element.nativeElement).getNativeWindow()
          .document;
        this.zone.runOutsideAngular(() => {
          document.addEventListener("mousemove", (...args) => {
            console.log(`dataTable.onDocumentMouseMove(%O)`, args);
            this.onDocumentMouseMove.call(this, ...args);
          });
        });
        this.documentColumnResizeEndListener = this.renderer.listen(
          document,
          "mouseup",
          (event) => {
            if (this.columnResizing) {
              this.columnResizing = false;
              this.onColumnResizeEnd.call(this, event);
            }
          },
        );
      }.bind(dataTable);
    }
  }
}
